const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.1207 9.93623C17.5547 9.50222 17.5547 8.79856 17.1207 8.36455L10.0481 1.29201C9.61414 0.858005 8.91048 0.858005 8.47647 1.29201C8.04246 1.72602 8.04246 2.42968 8.47647 2.86369L14.7632 9.15039L8.47647 15.4371C8.04246 15.8711 8.04246 16.5748 8.47647 17.0088C8.91048 17.4428 9.61414 17.4428 10.0481 17.0088L17.1207 9.93623ZM0.0351562 10.2617H16.3348V8.03905H0.0351562V10.2617Z",
    fill: "#4AB7D9",
    style: {
      fill: "#4AB7D9",
      fill: "color(display-p3 0.2902 0.7176 0.8510)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.b5ffb6dc37cc28b19ad28882a87ad786.svg";
export { ForwardRef as ReactComponent };